import React, { useEffect, useState } from "react";
import { checkServerConnection, getMovieDetails, searchMovieInHouse, setFavMovie, updateMovieDetails } from "../Globals/globalFunctions";
import { getMovieDetailsFromAI } from "../Globals/globalFunctions";
import { toast } from "react-toastify";
import { ToastConfig } from "../Globals/globalMetaData";
import Loader from "./Components/Loader";
import Tippy from "@tippyjs/react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Login from "./Components/Login";

const WarningToast = ({ closeToast }) => {
  return (
    <>
      <div className="wrapper">
        <h5>Warning!</h5>
        <p>You are not connected to the Server. Click <b>Allow</b> to connect. <Link to='/dev-notes' onClick={() => closeToast()}>Read More</Link>. <b>Close</b> the popup if you already have access! Enjoy!</p>
        <div className="d-flex justify-content-between position-relative" style={{ zIndex: 1 }}>
          <button onClick={() => { window.open("https://api.playjeeto.in:5000/", '_blank'); closeToast(); }}>
            Allow
          </button>
          <button onClick={() => closeToast()} style={{ background: '#2c2c2c' }}>Close</button>
        </div>
      </div>
    </>
  );
};

function Home() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [movieDetailsArr, setMovieDetailsArr] = useState([]);
  const [peskyShit, setPeskyShit] = useState(true);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    checkServer();
  }, [])

  const checkServer = async () => {
    const serverStatus = toast.loading('Checking Server Connection! Please Wait!', ToastConfig);
    try {
      const res = await checkServerConnection();
      if (res === 200) {
        toast.update(serverStatus, {
          render: "Connected to Server!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
        setPeskyShit(false);
      } else {
        toast.dismiss();
        toast(({ closeToast }) => <WarningToast closeToast={(param) => {
          closeToast();
          setTimeout(() => {
            setPeskyShit(false);
          }, 500)
        }
        } />, {
          position: 'top-center',
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          closeButton: false,
          className: 'customToast',
        })
      }
    } catch (error) {
      toast.error(error, ToastConfig);
    }
  }

  const handleSearch = async () => {
    if (searchQuery.trim() !== "") {
      setLoading(true);
      setMovieDetailsArr([]);
      try {
        const movieDetailsFromAI = await getMovieDetailsFromAI(searchQuery);

        if (movieDetailsFromAI.length > 0) {
          const fetchedMovieDetails = [];
          for (let i = 0; i < movieDetailsFromAI.length; i++) {
            try {
              const movieDetails = await searchMovieInHouse(
                movieDetailsFromAI[i].name,
                movieDetailsFromAI[i].year
              );
              if (movieDetails) {
                fetchedMovieDetails.push(movieDetails);
              } else {
                try {
                  const movieDetails = await getMovieDetails(
                    movieDetailsFromAI[i].name,
                    movieDetailsFromAI[i].year
                  );
                  if (movieDetails) {
                    fetchedMovieDetails.push(movieDetails);
                    const pushDataInDB = updateMovieDetails(movieDetails.title, movieDetails.year, movieDetails.rated, movieDetails.released, movieDetails.runtime, movieDetails.genre, movieDetails.director, movieDetails.writer, movieDetails.actors, movieDetails.plot, movieDetails.language, movieDetails.country, movieDetails.awards, movieDetails.poster, movieDetails.metascore, movieDetails.imdb_rating, movieDetails.imdb_id, movieDetails.box_office);
                  } else {
                    toast.error(`Sorry! ${movieDetailsFromAI[i].name} is not available!`, ToastConfig);
                  }
                } catch (error) {
                  toast.error(`Sorry! ${movieDetailsFromAI[i].name} is not available!`, ToastConfig);
                }
              }
            } catch (error) {
              toast.error(`Sorry! Couldn't connect with server!`, ToastConfig);
            }
          }
          setMovieDetailsArr(fetchedMovieDetails);
          console.log(fetchedMovieDetails);

        } else {
          toast.error("No movie details found! Be specific!", ToastConfig);
          return;
        }
      } catch (error) {
        toast.error(error, ToastConfig);
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please enter a movie plot to search", ToastConfig);
    }
  };

  useEffect(() => {
    if (loading || Object.keys(movieDetailsArr).length > 0) {
      document.querySelector(".searchConsole h1").style.opacity = 0;
      document.querySelector(".searchConsole p").style.opacity = 0;

      document.querySelector(".searchConsole h1").style.lineHeight = 0;
      document.querySelector(".searchConsole p").style.lineHeight = 0;

      document.querySelector(".searchConsole h1").style.marginBottom = 0;
      document.querySelector(".searchConsole p").style.marginBottom = 0;
    } else {
      document.querySelector(".searchConsole h1").style.opacity = 1;
      document.querySelector(".searchConsole p").style.opacity = 1;

      document.querySelector(".searchConsole h1").style.lineHeight = '1.2';
      document.querySelector(".searchConsole p").style.lineHeight = '1.5';

      document.querySelector(".searchConsole h1").style.marginBottom = '20px';
      document.querySelector(".searchConsole p").style.marginBottom = '50px';
    }
  }, [loading]);

  const clearSearch = () => {
    setSearchQuery('');
    setMovieDetailsArr([]);
    window.scrollTo(0, 0);
  }

  const handleAddFav = async (movieID) => {
    if (user.userid) {
      try {
        const data = await setFavMovie(movieID, user.userid);
        if (data) {
          toast.success("Added to Favourites!", ToastConfig);
        }
      } catch (error) {
        toast.error(error, ToastConfig);
      }
    } else {
      setShowLogin(true);
      toast.error('Please Log In!', ToastConfig);
    }
  }

  return (
    <>
      {peskyShit && <div className="somePeskyShit"></div>}
      {showLogin && <Login closeLogin={() => setShowLogin(false)} />}
      <main>
        <div className="container">
          <div className="row">
            <div className="col-xl-12 mt-5">
              <div className="searchConsole">
                <div className="col-xxl-6 col-xl-8 mx-auto">
                  <div>
                    <h1>
                      Can't Remember the Movie Name? Let Us Find It for You!
                    </h1>
                    <p>
                      Lost the title but remember the story? No worries! Just
                      describe the movie plot, and we'll track down the exact film
                      for you—fast and accurately. 🎬✨
                    </p>
                    <div class="input-container">
                      <input
                        placeholder="Search for a plot ;)"
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                      <button onClick={handleSearch}>
                        <i class="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12 mt-5" style={{ minHeight: '300px' }}>
              {movieDetailsArr && movieDetailsArr.length > 0 && !loading ? (
                movieDetailsArr.map((movieDetails, index) => (
                  <div className="movieBlock" key={index}>
                    <div className="imgWrapper">
                      <img src={`${movieDetails?.poster}`} />
                      <button className="favouriteBtn" onClick={() => handleAddFav(movieDetails?.imdb_id)}><i class="fa-regular fa-heart"></i></button>
                    </div>
                    <div className="content">
                      <h3>
                        {movieDetails?.title} <span>({movieDetails?.year})</span>
                      </h3>
                      <p>{movieDetails?.plot || 'N/A'}</p>
                      <ul>
                        <li>
                          <b>Released</b>: {movieDetails?.released || 'N/A'}
                        </li>
                        <li>
                          <b>Runtime</b>: {movieDetails?.runtime || 'N/A'}
                        </li>
                        <li>
                          <b>Genre</b>: {movieDetails?.genre || 'N/A'}
                        </li>
                        <li>
                          <b>Director</b>: {movieDetails?.director || 'N/A'}
                        </li>
                        <li>
                          <b>Actors</b>: {movieDetails?.actors || 'N/A'}
                        </li>
                        <li>
                          <b>Language</b>: {movieDetails?.language || 'N/A'}
                        </li>
                        <li>
                          <b>Country</b>: {movieDetails?.country || 'N/A'}
                        </li>
                        <li>
                          <b>Awards</b>: {movieDetails?.awards || 'N/A'}
                        </li>
                        <li className="rating">
                          <span>
                            <img src={require("../Assets/images/imdb.png")} />{" "}
                            {movieDetails?.imdb_rating || "N/A"}
                          </span>
                          <span>
                            <img src={require("../Assets/images/meta.png")} />{" "}
                            {movieDetails?.metascore || "N/A"}
                          </span>
                          {/* <span>
                            <img
                              src={require("../Assets/images/tomato.png")}
                              width={"20px"}
                            />{" "}
                            {movieDetails?.Ratings[2]?.Value || "N/A"}
                          </span> */}
                        </li>
                      </ul>
                      <div className="watchNow">
                        <a target="_blank" href={`https://vidbinge.dev/embed/movie/${movieDetails?.imdb_id}`}>
                          <span style={{ fontWeight: 300 }}>Watch On</span> Vid Binge
                        </a>
                        <a target="_blank" href={`https://player.autoembed.cc/embed/movie/${movieDetails?.imdb_id}`}>
                          <span style={{ fontWeight: 300 }}>Watch On</span> Autoembed
                        </a>
                        <a target="_blank" href={`https://vidsrc.cc/v2/embed/movie/${movieDetails?.imdb_id}`}>
                          <span style={{ fontWeight: 300 }}>Watch On</span> Vid Src
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : loading ? (
                <Loader />
              ) : ""}
            </div>
            {movieDetailsArr && movieDetailsArr.length > 1 && (
              <div className="clearButton">
                <Tippy content="Clear the search results">
                  <button onClick={clearSearch}><i class="fa-solid fa-xmark"></i></button>
                </Tippy>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default Home;

